module.exports = __webpack_public_path__ + "static/media/visa.3ff3af70.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/openpay/visa.png
// module id = 172
// module chunks = 0